import React from 'react';
import { Edit, Trash2 } from 'lucide-react';
import { Alert } from '../../types/index';
import { Button } from '../atoms/Button';
import { Card } from '../atoms/Card';

interface AlertCardProps {
  alert: Alert;
  onEdit: (alert: Alert) => void;
  onDelete: (id: string) => void;
}

export const AlertCard: React.FC<AlertCardProps> = ({ alert, onEdit, onDelete }) => (
  <Card className="p-4" data-testid={`alert-card-${alert.id}`}>
    <div className="flex justify-between items-start">
      <div>
        <h3 className="font-semibold text-gray-900 dark:text-white">{alert.symbol}</h3>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          Alert when price {alert.condition} ${alert.targetPrice}
        </p>
        <p className="text-xs text-gray-500 mt-1">
          Created: {new Date(alert.created).toLocaleDateString()}
        </p>
      </div>
      <div className="flex gap-1">
        <Button size="sm" variant="ghost" onClick={() => onEdit(alert)} data-testid={`edit-alert-${alert.id}`}>
          <Edit size={16} />
        </Button>
        <Button size="sm" variant="ghost" onClick={() => onDelete(alert.id)} data-testid={`delete-alert-${alert.id}`}>
          <Trash2 size={16} />
        </Button>
      </div>
    </div>
  </Card>
);